function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.95002 0.5C4.70002 0.5 1.92502 2.6 0.900024 5.5H15.05C14 2.6 11.225 0.5 7.95002 0.5Z",
  fill: "#F2B200"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.95002 15.5C11.225 15.5 14 13.425 15.025 10.5H0.900024C1.92502 13.425 4.70002 15.5 7.95002 15.5Z",
  fill: "#83BF4F"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0.899976 5.5C0.624976 6.275 0.474976 7.125 0.474976 8C0.474976 8.875 0.624976 9.725 0.899976 10.5H15.05C15.325 9.725 15.475 8.875 15.475 8C15.475 7.125 15.325 6.275 15.05 5.5H0.899976Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M7.95001 10C9.05458 10 9.95001 9.10457 9.95001 8C9.95001 6.89543 9.05458 6 7.95001 6C6.84544 6 5.95001 6.89543 5.95001 8C5.95001 9.10457 6.84544 10 7.95001 10Z",
  fill: "#428BC1"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M7.95001 9.75C8.91651 9.75 9.70001 8.9665 9.70001 8C9.70001 7.0335 8.91651 6.25 7.95001 6.25C6.98351 6.25 6.20001 7.0335 6.20001 8C6.20001 8.9665 6.98351 9.75 7.95001 9.75Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M7.29999 6.5C7.36902 6.5 7.42499 6.44404 7.42499 6.375C7.42499 6.30596 7.36902 6.25 7.29999 6.25C7.23095 6.25 7.17499 6.30596 7.17499 6.375C7.17499 6.44404 7.23095 6.5 7.29999 6.5Z",
  fill: "#428BC1"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M6.89996 6.72485C6.969 6.72485 7.02496 6.66889 7.02496 6.59985C7.02496 6.53082 6.969 6.47485 6.89996 6.47485C6.83093 6.47485 6.77496 6.53082 6.77496 6.59985C6.77496 6.66889 6.83093 6.72485 6.89996 6.72485Z",
  fill: "#428BC1"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M6.57495 7.0498C6.64399 7.0498 6.69995 6.99384 6.69995 6.9248C6.69995 6.85577 6.64399 6.7998 6.57495 6.7998C6.50592 6.7998 6.44995 6.85577 6.44995 6.9248C6.44995 6.99384 6.50592 7.0498 6.57495 7.0498Z",
  fill: "#428BC1"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M6.34998 7.44995C6.41901 7.44995 6.47498 7.39399 6.47498 7.32495C6.47498 7.25592 6.41901 7.19995 6.34998 7.19995C6.28094 7.19995 6.22498 7.25592 6.22498 7.32495C6.22498 7.39399 6.28094 7.44995 6.34998 7.44995Z",
  fill: "#428BC1"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M6.22498 7.8999C6.29401 7.8999 6.34998 7.84394 6.34998 7.7749C6.34998 7.70587 6.29401 7.6499 6.22498 7.6499C6.15594 7.6499 6.09998 7.70587 6.09998 7.7749C6.09998 7.84394 6.15594 7.8999 6.22498 7.8999Z",
  fill: "#428BC1"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M6.22498 8.34985C6.29401 8.34985 6.34998 8.29389 6.34998 8.22485C6.34998 8.15582 6.29401 8.09985 6.22498 8.09985C6.15594 8.09985 6.09998 8.15582 6.09998 8.22485C6.09998 8.29389 6.15594 8.34985 6.22498 8.34985Z",
  fill: "#428BC1"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M6.34998 8.7998C6.41901 8.7998 6.47498 8.74384 6.47498 8.6748C6.47498 8.60577 6.41901 8.5498 6.34998 8.5498C6.28094 8.5498 6.22498 8.60577 6.22498 8.6748C6.22498 8.74384 6.28094 8.7998 6.34998 8.7998Z",
  fill: "#428BC1"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M6.57495 9.19995C6.64399 9.19995 6.69995 9.14399 6.69995 9.07495C6.69995 9.00592 6.64399 8.94995 6.57495 8.94995C6.50592 8.94995 6.44995 9.00592 6.44995 9.07495C6.44995 9.14399 6.50592 9.19995 6.57495 9.19995Z",
  fill: "#428BC1"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M6.89996 9.5249C6.969 9.5249 7.02496 9.46894 7.02496 9.3999C7.02496 9.33087 6.969 9.2749 6.89996 9.2749C6.83093 9.2749 6.77496 9.33087 6.77496 9.3999C6.77496 9.46894 6.83093 9.5249 6.89996 9.5249Z",
  fill: "#428BC1"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M7.29999 9.75C7.36902 9.75 7.42499 9.69404 7.42499 9.625C7.42499 9.55596 7.36902 9.5 7.29999 9.5C7.23095 9.5 7.17499 9.55596 7.17499 9.625C7.17499 9.69404 7.23095 9.75 7.29999 9.75Z",
  fill: "#428BC1"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M7.72498 9.84985C7.79401 9.84985 7.84998 9.79389 7.84998 9.72485C7.84998 9.65582 7.79401 9.59985 7.72498 9.59985C7.65594 9.59985 7.59998 9.65582 7.59998 9.72485C7.59998 9.79389 7.65594 9.84985 7.72498 9.84985Z",
  fill: "#428BC1"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M8.07495 9.74985C8.07495 9.67485 8.12495 9.62485 8.17495 9.59985C8.24995 9.59985 8.29995 9.64985 8.32495 9.69985C8.32495 9.77485 8.27495 9.82485 8.22495 9.84985C8.12495 9.87485 8.07495 9.82485 8.07495 9.74985Z",
  fill: "#428BC1"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M8.625 9.75C8.69404 9.75 8.75 9.69404 8.75 9.625C8.75 9.55596 8.69404 9.5 8.625 9.5C8.55596 9.5 8.5 9.55596 8.5 9.625C8.5 9.69404 8.55596 9.75 8.625 9.75Z",
  fill: "#428BC1"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M9.02496 9.5249C9.094 9.5249 9.14996 9.46894 9.14996 9.3999C9.14996 9.33087 9.094 9.2749 9.02496 9.2749C8.95593 9.2749 8.89996 9.33087 8.89996 9.3999C8.89996 9.46894 8.95593 9.5249 9.02496 9.5249Z",
  fill: "#428BC1"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M9.34998 9.19995C9.41901 9.19995 9.47498 9.14399 9.47498 9.07495C9.47498 9.00592 9.41901 8.94995 9.34998 8.94995C9.28094 8.94995 9.22498 9.00592 9.22498 9.07495C9.22498 9.14399 9.28094 9.19995 9.34998 9.19995Z",
  fill: "#428BC1"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M9.57495 8.7998C9.64399 8.7998 9.69995 8.74384 9.69995 8.6748C9.69995 8.60577 9.64399 8.5498 9.57495 8.5498C9.50592 8.5498 9.44995 8.60577 9.44995 8.6748C9.44995 8.74384 9.50592 8.7998 9.57495 8.7998Z",
  fill: "#428BC1"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M9.69995 8.34985C9.76899 8.34985 9.82495 8.29389 9.82495 8.22485C9.82495 8.15582 9.76899 8.09985 9.69995 8.09985C9.63092 8.09985 9.57495 8.15582 9.57495 8.22485C9.57495 8.29389 9.63092 8.34985 9.69995 8.34985Z",
  fill: "#428BC1"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M9.69999 7.8999C9.62499 7.8999 9.57499 7.8499 9.54999 7.7999C9.54999 7.7249 9.59999 7.6749 9.64999 7.6499C9.72499 7.6499 9.77499 7.6999 9.79999 7.7499C9.82499 7.8249 9.77499 7.8749 9.69999 7.8999Z",
  fill: "#428BC1"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M9.57495 7.44995C9.64399 7.44995 9.69995 7.39399 9.69995 7.32495C9.69995 7.25592 9.64399 7.19995 9.57495 7.19995C9.50592 7.19995 9.44995 7.25592 9.44995 7.32495C9.44995 7.39399 9.50592 7.44995 9.57495 7.44995Z",
  fill: "#428BC1"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M9.34998 7.0498C9.41901 7.0498 9.47498 6.99384 9.47498 6.9248C9.47498 6.85577 9.41901 6.7998 9.34998 6.7998C9.28094 6.7998 9.22498 6.85577 9.22498 6.9248C9.22498 6.99384 9.28094 7.0498 9.34998 7.0498Z",
  fill: "#428BC1"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M9.02496 6.72485C9.094 6.72485 9.14996 6.66889 9.14996 6.59985C9.14996 6.53082 9.094 6.47485 9.02496 6.47485C8.95593 6.47485 8.89996 6.53082 8.89996 6.59985C8.89996 6.66889 8.95593 6.72485 9.02496 6.72485Z",
  fill: "#428BC1"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M8.74998 6.42485C8.72498 6.49985 8.64998 6.52485 8.57498 6.49985C8.49998 6.47485 8.47498 6.39985 8.49998 6.32485C8.52498 6.24985 8.59998 6.22485 8.67498 6.24985C8.74998 6.29985 8.77498 6.37485 8.74998 6.42485Z",
  fill: "#428BC1"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M8.29996 6.27491C8.29996 6.34991 8.22496 6.39991 8.14996 6.37491C8.07496 6.37491 8.02496 6.29991 8.04996 6.22491C8.04996 6.14991 8.12496 6.09991 8.19996 6.12491C8.27496 6.14991 8.32496 6.22491 8.29996 6.27491Z",
  fill: "#428BC1"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M7.84998 6.24981C7.84998 6.32481 7.79998 6.37481 7.74998 6.39981C7.67498 6.39981 7.62498 6.34981 7.59998 6.29981C7.59998 6.22481 7.64998 6.17481 7.69998 6.14981C7.77498 6.12481 7.84998 6.17481 7.84998 6.24981Z",
  fill: "#428BC1"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M7.94995 8.375C8.15706 8.375 8.32495 8.20711 8.32495 8C8.32495 7.79289 8.15706 7.625 7.94995 7.625C7.74284 7.625 7.57495 7.79289 7.57495 8C7.57495 8.20711 7.74284 8.375 7.94995 8.375Z",
  fill: "#428BC1"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M7.94996 6.25L7.89996 7.325L7.94996 8L8.02496 7.325L7.94996 6.25Z",
  fill: "#428BC1"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M7.5 6.2998L7.725 7.3748L7.95 7.9998L7.85 7.3248L7.5 6.2998Z",
  fill: "#428BC1"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M7.07495 6.47485L7.57495 7.44985L7.94995 7.99985L7.67495 7.37485L7.07495 6.47485Z",
  fill: "#428BC1"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M6.72498 6.75L7.44998 7.575L7.94998 8L7.52498 7.475L6.72498 6.75Z",
  fill: "#428BC1"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M6.44995 7.125L7.34995 7.725L7.94995 8L7.39995 7.6L6.44995 7.125Z",
  fill: "#428BC1"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M6.27496 7.5498L7.29996 7.8748L7.94996 7.9998L7.32496 7.7748L6.27496 7.5498Z",
  fill: "#428BC1"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M6.19995 7.99995L7.29995 8.04995L7.94995 7.99995L7.29995 7.94995L6.19995 7.99995Z",
  fill: "#428BC1"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M6.27496 8.45L7.32496 8.225L7.94996 8L7.29996 8.125L6.27496 8.45Z",
  fill: "#428BC1"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M6.44995 8.875L7.39995 8.4L7.94995 8L7.34995 8.275L6.44995 8.875Z",
  fill: "#428BC1"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M6.72498 9.225L7.52498 8.525L7.94998 8L7.44998 8.425L6.72498 9.225Z",
  fill: "#428BC1"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M7.07495 9.525L7.67495 8.6L7.94995 8L7.57495 8.55L7.07495 9.525Z",
  fill: "#428BC1"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M7.5 9.7L7.85 8.675L7.95 8L7.725 8.625L7.5 9.7Z",
  fill: "#428BC1"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M7.94996 9.75L8.02496 8.675L7.94996 8L7.89996 8.675L7.94996 9.75Z",
  fill: "#428BC1"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M8.39995 9.7L8.19995 8.625L7.94995 8L8.07495 8.675L8.39995 9.7Z",
  fill: "#428BC1"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M8.82495 9.525L8.34995 8.55L7.94995 8L8.24995 8.625L8.82495 9.525Z",
  fill: "#428BC1"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M9.19995 9.225L8.47495 8.425L7.94995 8L8.39995 8.525L9.19995 9.225Z",
  fill: "#428BC1"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M9.47495 8.875L8.57495 8.275L7.94995 8L8.49995 8.4L9.47495 8.875Z",
  fill: "#428BC1"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M9.64995 8.45L8.62495 8.125L7.94995 8L8.59995 8.225L9.64995 8.45Z",
  fill: "#428BC1"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M9.69995 7.9998L8.62495 7.9248L7.94995 7.9998L8.62495 8.0498L9.69995 7.9998Z",
  fill: "#428BC1"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M9.64995 7.5498L8.59995 7.7748L7.94995 7.9998L8.62495 7.8748L9.64995 7.5498Z",
  fill: "#428BC1"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M9.47495 7.125L8.49995 7.6L7.94995 8L8.57495 7.725L9.47495 7.125Z",
  fill: "#428BC1"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M9.19995 6.7749L8.39995 7.4749L7.94995 7.9999L8.47495 7.5749L9.19995 6.7749Z",
  fill: "#428BC1"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M8.82495 6.47485L8.24995 7.39985L7.94995 7.99985L8.34995 7.44985L8.82495 6.47485Z",
  fill: "#428BC1"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M8.42495 6.2998L8.07495 7.3248L7.94995 7.9998L8.19995 7.3748L8.42495 6.2998Z",
  fill: "#428BC1"
});

function SvgIndiaFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndiaFlag);
export default __webpack_public_path__ + "static/media/india-flag.1268af87.svg";
export { ForwardRef as ReactComponent };